import axios from "axios";
import { ApiPathRESE } from "../../../common/api-path/ApiPath";

const ensureArray = (data) => Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];
const getUsecaseFromUrl = () => {
    const pathname = (typeof window !== "undefined" && window.location && window.location.pathname) || "";
    if (pathname.includes("admin/rese/leak-detection-alert-suppression-request")) {
        return "leak-detection";
    }
    if (pathname.includes("admin/rese/alert-suppression-request")) {
        return "energy-meter";
    }
    return null;
};

export const getAlertSuppressionReasons = async () => {
    const usecase = getUsecaseFromUrl();
    const requestConfig = {
        timeout: 120000,
        timeoutErrorMessage: "request timeout",
        headers: {
            ...(usecase ? { usecase } : {}),
        },
    };
    const response = await axios.get(
        `${ApiPathRESE.baseUrl}/getAlertSuppressionReasonDetails`,
        requestConfig
    );
    if (response.status >= 400) {
        throw new Error(response.error);
    }
    return ensureArray(response.data);
};
export const getAlertSuppressionScope = async () => {
    const usecase = getUsecaseFromUrl();
    const requestConfig = {
        timeout: 120000,
        timeoutErrorMessage: "request timeout",
        headers: {
            ...(usecase ? { usecase } : {}),
        },
    };
    const response = await axios.get(
        `${ApiPathRESE.baseUrl}/getAlertSuppressionScopes`,
        requestConfig
    );
    if (response.status >= 400) {
        throw new Error(response.error);
    }
    return ensureArray(response.data);
};

export const postAlertSuppressionInformation = async (alertInfo) => {
    const usecase = getUsecaseFromUrl();

    let payload = alertInfo;
    if (usecase === "leak-detection" && alertInfo && typeof alertInfo === "object") {
        const { point_id, system_id, scope_id, ...rest } = alertInfo;
        payload = rest;
    }

    const requestConfig = {
        timeout: 120000,
        timeoutErrorMessage: "request timeout",
        headers: {
            ...(usecase ? { usecase } : {}),
        },
    };

    const response = await axios.post(
        `${ApiPathRESE.baseUrl}/addAlertSuppressionDetails`,
        payload,
        requestConfig
    );
    if (response.status >= 400) {
        throw new Error(response.error);
    }
    return response.data;
};

export const getAlertSuppressionLogs = async (startDatetime, endDatetime, offset, usecase) => {
    const requestConfig = {
        params: {startDatetime, endDatetime, offset},
        timeout: 120000,
        timeoutErrorMessage: "request timeout",
        headers: {
            ...(usecase ? { usecase } : {}),
        },
    }
    const response = await axios.get (`${ApiPathRESE.baseUrl}/getAlertSuppressionDetails`, requestConfig);
    if (response.status >= 400) {
        throw new Error(response.error);
    }
    return ensureArray(response.data);
}

export const deleteAlertSuppressionRequest = async (suppressionId, workStatus, usecase) => {
    const requestConfig = {
        params: {suppressionId, workStatus},
        timeout: 120000,
        timeoutErrorMessage: "request timeout",
        headers: {
            ...(usecase ? { usecase } : {}),
        },
    }
    const response = await axios.delete(`${ApiPathRESE.baseUrl}/deleteAlertSuppressionDetails`, requestConfig);
    if (response.status >= 400) {
        throw new Error(response.error);
    }
    return response.data;
}

